import { VISUALIZATION } from "@/schemas/question/visualization";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import EnumSelect from "@/components/EnumSelect";

const VisualizationTypeSelect = forwardRef<
  HTMLButtonElement,
  ControllerRenderProps
>((props, ref) => (
  <EnumSelect
    options={VISUALIZATION}
    translationKey="visualizationTypes"
    {...props}
    ref={ref}
  />
));

export default VisualizationTypeSelect;
